import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CourtDeadlineRule from '../../entities/courtDeadlineRule';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteCourtDeadlineRule(): boolean {
return true;
}
export function collectCourtDeadlineRuleDeleteImpact(courtDeadlineRule: CourtDeadlineRule, context: DeleteImpactContext): void {
const key = 'courtDeadlineRule:' + courtDeadlineRule.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactCourtDeadlineRule(courtDeadlineRule: CourtDeadlineRule): DeleteImpact {
const context = deleteImpactContext();
collectCourtDeadlineRuleDeleteImpact(courtDeadlineRule, context);
return deleteImpactCounts(context);
}
export function deleteCourtDeadlineRule(courtDeadlineRule: CourtDeadlineRule, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteCourtDeadlineRule()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectCourtDeadlineRuleDeleteImpact(courtDeadlineRule, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || courtDeadlineRule.id};
}
const key = 'courtDeadlineRule:' + courtDeadlineRule.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = courtDeadlineRule.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.CourtDeadlineRuleActions.removeCourtDeadlineRuleQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
